<template>
  <div>
    <div class="radius_bg">
      <el-date-picker
          v-model="formData.date"
          placeholder="月份选择"
          type="month"
          format="yyyy年MM月"
          value-format="yyyy-MM"
          @change="handleTab">
      </el-date-picker>
      <el-button style="margin-left: 10px" @click='handleTab' type='primary' icon='el-icon-search'>查询</el-button>
      <br/><br/>
    </div>
    <div class="default-table radius_bg" style="padding-bottom: 20px">
      <el-table :data="dataList" ref="multipleTable" row-key="id"
                id="kolAnalysisTable"
                highlight-current-row :summary-method="getSummaries"
                @cell-click="showInput" :cell-class-name='addCellClass'
                show-summary v-loading="isLoading" border>
        <el-table-column align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column align="center" prop="leader_name" show-overflow-tooltip label="姓名"
                         width="120"></el-table-column>
        <el-table-column align="center" prop="created_at" show-overflow-tooltip label="时间"
                         width="180">
          <template slot-scope="{row}">{{ row.created_at.slice(0, 7) }}</template>
        </el-table-column>
        <el-table-column align="center" prop="commit_count" label="提交商品" width="100" sortable/>
        <el-table-column align="center" prop="check_count" label="通过商品" width="100" sortable/>
        <el-table-column align="center" prop="brand_count" label="品牌数" width="100" sortable/>
        <el-table-column align="center" prop="new_brand_count" label="品牌拓新数" width="100" sortable/>
      </el-table>
    </div>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-card class="box-card" ref="card">
          <div slot="header" class="clearfix">
            <div>
              <span>产品库统计</span>
              <el-button size="mini" type="primary" plain icon="el-icon-upload2" style="float: right;"
                         @click="$refs.feishuSyncDialog.open('product_library')" v-permission="'dashboard_btn_sync_fs'">
                同步到飞书
              </el-button>

              <!--              <el-link style="float: right;margin-left: 10px" type="primary" :underline="false"-->
              <!--                       title="点击刷新"-->
              <!--                       @click="getData"><i class="el-icon-refresh-right"/></el-link>-->
            </div>
            <el-radio-group v-model="skinTable.nm" style="margin-bottom: 30px;" @change="handleSkinTabClick">
              <el-radio-button label="品类"/>
              <el-radio-button label="佣金梯度"/>
              <el-radio-button label="招商"/>
              <el-radio-button label="平台"/>
            </el-radio-group>
          </div>


          <el-table class="dashboard-table"
                    show-summary
                    :data="skinTable.data"
                    :row-style="{ border: 'none',padding:'15px 0'}"
                    :cell-style="{ border: 'none'}"
                    :default-sort="{ prop: this.skinTable.sort.sort_key, order: 'descending' }"
                    @sort-change="changeSkinTableSort"
                    style="width: 100%">
            <el-table-column type="index" label="序号" width="65"></el-table-column>
            <el-table-column prop="name" label="分类" width="130"/>
            <el-table-column prop="cNum" label="产品数量" width="100" align="right" sortable/>
            <el-table-column prop="week_num" label="上周新增" width="100" align="right" sortable/>
            <el-table-column prop="month_num" label="上月新增" width="100" align="right" sortable/>
            <el-table-column prop="bNum" label="品牌数" width="100" align="right" sortable/>
            <el-table-column prop="week_b_num" label="上周新增品牌数" align="right" sortable/>
            <el-table-column prop="month_b_num" label="上月新增品牌数" align="right" sortable/>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card" ref="card">
          <div slot="header" class="clearfix">
            <div>
              <span>视频号专区统计</span>
              <el-button size="mini" type="primary" plain icon="el-icon-upload2" style="float: right;"
                         @click="$refs.feishuSyncDialog.open('video_zone')" v-permission="'dashboard_btn_sync_fs'">同步到飞书
              </el-button>

              <!--              <el-link style="float: right;margin-left: 10px" type="primary" :underline="false"-->
              <!--                       title="点击刷新"-->
              <!--                       @click="getData"><i class="el-icon-refresh-right"/></el-link>-->
            </div>
            <el-radio-group v-model="videoTable.nm" style="margin-bottom: 30px;" @change="handleVideoTabClick">
              <el-radio-button label="品类"/>
              <el-radio-button label="佣金梯度"/>
              <el-radio-button label="招商"/>
              <el-radio-button label="平台"/>
            </el-radio-group>
          </div>
          <el-table class="dashboard-table"
                    show-summary
                    :data="videoTable.data"
                    :row-style="{ border: 'none',padding:'15px 0'}"
                    :cell-style="{ border: 'none'}"
                    :default-sort="{ prop: this.videoTable.sort.sort_key, order: 'descending' }"
                    @sort-change="changeVideoTableSort"
                    style="width: 100%">
            <el-table-column type="index" label="序号" width="65"></el-table-column>
            <el-table-column prop="name" label="分类" width="130"/>
            <el-table-column prop="cNum" label="产品数量" width="100" align="right" sortable/>
            <el-table-column prop="week_num" label="上周新增" width="100" align="right" sortable/>
            <el-table-column prop="month_num" label="上月新增" width="100" align="right" sortable/>
            <el-table-column prop="bNum" label="品牌数" width="100" align="right" sortable/>
            <el-table-column prop="week_b_num" label="上周新增品牌数" align="right" sortable/>
            <el-table-column prop="month_b_num" label="上月新增品牌数" align="right" sortable/>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="11">
        <el-card class="box-card" ref="card">
          <div slot="header" class="clearfix">
            直播佣金认领统计
            <el-link style="float: right;margin-left: 10px" type="primary" :underline="false"
                     title="点击刷新"
                     @click="getData"><i class="el-icon-refresh-right"/></el-link>
          </div>
          <el-table class="dashboard-table"
                    show-summary
                    :data="data"
                    :row-style="{ border: 'none',padding:'15px 0'}"
                    :cell-style="{ border: 'none'}"
                    style="width: 100%">
            <el-table-column type="index" label="排名" width="80"></el-table-column>
            <el-table-column prop="name" label="招商" width="85"/>
            <el-table-column prop="order_count" label="订单数" align="right" sortable/>
            <el-table-column prop="order_money" :label="`佣金收入(元)`" align="right"
                             sortable>
              <template slot-scope="{row:{order_money}}">
                <span class="money">{{ gFunc.numberFormat(order_money) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog :title='brandFrom.info.title' :visible.sync='brandFrom.open' center width='50%' append-to-body
               :close-on-click-modal='true'>
      <div style="width: 95%;margin: 20px auto">
        <el-table :data="brandFrom.list" border style="width: 100%">
          <el-table-column type="index" width="50" label='序号' header-align="center" align="center"/>
          <el-table-column prop="name" label="品牌名称" min-width="200" header-align="center" align="center"/>
          <el-table-column prop="contact_user" label="联系人" min-width="60" header-align="center" align="right"/>
          <el-table-column prop="contact_info" label="联系电话" min-width="120" header-align="center" align="center"/>
          <el-table-column prop="created_at" label="录入时间" min-width="120" header-align="center" align="center"/>
        </el-table>
      </div>
      <div>
        <el-row>
          <el-col :span="8">
            <div class="bottom-bar"></div>
          </el-col>
          <el-col :span="16" style="text-align: right">
            <el-pagination
                background
                :current-page="brandFrom.pageData.page"
                :page-sizes="[5,10,20,100, 200, 300, 400]"
                :page-size="brandFrom.pageData.page_size"
                layout="total, sizes, prev, pager, next"
                :total="brandFrom.pageData.total"
                style="margin-top: 10px;float: right;"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
            />
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <feishu-sync-dialog ref="feishuSyncDialog" :scopes="syncScopes" :condition="condition"
                        :params="syncFeishuParams"/>
  </div>
</template>

<script>
import {
  getLiveGuaranteeRebateClaimStat,
  getPdProductStat,
  getSummaryInvestmentList,
  getSummaryNewBrandList
} from "@/api/home";
import {
  feishuProductLibrarySyncConfig,
  saveFeishuProductLibrarySyncConfig,
  feishuSyncProductLibrary,
  feishuVideoZoneSyncConfig,
  saveFeishuVideoZoneSyncConfig,
  feishuSyncVideoZone
} from "@/api/feishu";
import FeishuSyncDialog from "@/components/summary/FeishuSyncDialog.vue";

// 「同步到飞书」维度配置（共用 FeishuSyncDialog）
const SYNC_SCOPES = {
  product_library: {
    label: '产品库统计',
    entity: '产品库',
    rowHint: '每个分类写入一条记录',
    withMonth: true,
    getConfig: feishuProductLibrarySyncConfig,
    saveConfig: saveFeishuProductLibrarySyncConfig,
    sync: feishuSyncProductLibrary
  },
  video_zone: {
    label: '视频号专区统计',
    entity: '视频号专区',
    rowHint: '每个分类写入一条记录',
    withMonth: true,
    getConfig: feishuVideoZoneSyncConfig,
    saveConfig: saveFeishuVideoZoneSyncConfig,
    sync: feishuSyncVideoZone
  }
}

export default {
  name: 'SummaryInvestment',
  inject: ['condition'],
  components: {FeishuSyncDialog},
  data() {
    return {
      // 同步到飞书：维度配置（共用 FeishuSyncDialog）
      syncScopes: SYNC_SCOPES,
      formData: {date: ''},
      dataList: [],
      isLoading: false,
      downloadLoading: false,
      today: '',
      autoScroll: false,
      brandFrom: {
        info: {title: '', suffixTitle: '品牌拓新列表'},
        open: false,
        queryData: {leader_id: null, Ymd: null},
        pageData: {current_page: 1, page_size: 10, total: 0},
        orderBy: {created_at: 'desc'},
        list: []
      },
      data: [],
      skinTable: {
        nm: "品类",
        sort: {
          sort_key: "cNum",
          sort_val: "desc",
        },
        data: [],
      },
      videoTable: {
        nm: "品类",
        sort: {
          sort_key: "cNum",
          sort_val: "desc",
        },
        data: [],
      },
      pdFieldMap: {'品类': 'category_id', '佣金梯度': 'online_cmn', '招商': 'leader_id', '平台': 'platform_code',},
      pdProductTypeMap: {
        skin: 1,
        dress: 2,
        video: 3,
      }
    }
  },
  watch: {
    condition: {
      handler: function () {
        this.getData()
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 1) {
          return
        }
        if (index === 2) {
          sums[index] = '合计'
          return
        }
        if (['commit_count', 'check_count', 'brand_count', 'new_brand_count'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }

        }
      })
      return sums
    },
    handleTab() {
      this.getData()
      this.getList()
      this.getPdProductData()
    },
    // 「同步到飞书」维度参数（产品库 / 视频号按当前激活的分类维度与所选月份取数）
    syncFeishuParams(scopeKey) {
      const isVideo = scopeKey === 'video_zone'
      const tabNm = isVideo ? this.videoTable.nm : this.skinTable.nm
      const c_type = isVideo ? this.pdProductTypeMap.video : this.pdProductTypeMap.skin
      const field = this.pdFieldMap[tabNm] || 'category_id'
      const date = ((this.formData.date || this.today) + '').split('-')
      return {
        field,
        c_type,
        year: date[0],
        month: date[1],
        organization_id: this.condition.organization_id || ''
      }
    },
    async getList() {
      this.isLoading = true
      this.dataList = []
      //
      let selectInfo = {
        date: this.formData.date + '-01'
      }
      if (!this.formData.date) {
        selectInfo = {
          date: this.today + '-01'
        }
      }
      let {model} = await getSummaryInvestmentList(selectInfo)
      let {list} = model
      this.dataList = list
      this.isLoading = false
    },
    showInput(row, column) {
      if (column.property === 'new_brand_count') {
        if (row.leader_id && this.formData.date && row.new_brand_count > 0) {
          const Ymd = this.formData.date + '-01'
          this.brandFrom.queryData = {leader_id: row.leader_id, Ymd: Ymd}
          let YmdDate = new Date(Ymd)
          const Y = YmdDate.getFullYear()
          const Month = YmdDate.getMonth() + 1
          this.brandFrom.info.title = Y + '年' + Month + '月【' + row.leader_name + '】' + this.brandFrom.info.suffixTitle
          this.brandFrom.open = true
          this.getNewBrandList()
        } else {
          this.brandFrom.info.title = ''
        }
      }
    },
    // 取消按钮
    cancel() {
      this.brandFrom.open = false
      this.brandFrom.list = {leader_id: null, Ymd: null}
    },
    addCellClass({column}) {
      if (column && column.property === 'new_brand_count') {
        return 'cell-click'
      }
    },
    defaultTime() {
      const end = new Date()
      //年份选择：默认当月
      this.formData.date = end.getFullYear() + '-' + (Number(end.getMonth() + 1) < 10 ? '0' + Number(end.getMonth() + 1) : end.getMonth() + 1)
      this.today = end.getFullYear() + '-' + (Number(end.getMonth() + 1) < 10 ? '0' + Number(end.getMonth() + 1) : end.getMonth() + 1)
    },
    // 条件处理
    handleDialogSearchCondition(from) {
      let condition = from.queryData
      // 分页 +排序
      Object.assign(condition, from.pageData)
      return condition
    },
    async getNewBrandList() {
      let {model} = await getSummaryNewBrandList(this.handleDialogSearchCondition(this.brandFrom))
      let {list, pages} = model
      this.brandFrom.list = list
      this.brandFrom.pageData = pages
    },
    handleSizeChange(val) {
      this.brandFrom.pageData.page_size = val
      this.getNewBrandList()
    },
    handleCurrentChange(val) {
      this.brandFrom.pageData.current_page = val
      this.getNewBrandList()
    },
    getData() {
      let data = {}
      let year, month
      if (!this.formData.date) {
        let date = this.today.split('-')
        year = date[0]
        month = date[1]
      } else {
        let date = this.formData.date.split('-')
        year = date[0]
        month = date[1]
      }
      data = {
        year: year,
        month: month,
        organization_id: this.condition.organization_id || ''
      }
      getLiveGuaranteeRebateClaimStat(data).then(({data: {data}}) => {
        this.data = data;
        this.total_count = data.total_count
        this.total_money = data.total_money
      })
    },
    // 产品库排序
    changeSkinTableSort({prop, order}) {
      this.skinTable.sort.sort_key = prop
      this.skinTable.sort.sort_val = order === 'descending' ? 'desc' : 'asc'
      this.handleSkinTabClick()
    },
    // 视频号排序
    changeVideoTableSort({prop, order}) {
      this.videoTable.sort.sort_key = prop
      this.videoTable.sort.sort_val = order === 'descending' ? 'desc' : 'asc'
      this.handleVideoTabClick()
    },

    // 获取星象仪数据
    getPdProductData() {
      this.handleSkinTabClick()
      this.handleVideoTabClick()
    },

    // 获取产品库数据
    handleSkinTabClick() {
      const param = {
        field: this.pdFieldMap[this.skinTable.nm],
        c_type: this.pdProductTypeMap.skin,
        date_at: this.formData.date,
        ...this.skinTable.sort
      }
      // 获取数据
      getPdProductStat(param).then(({model: {list}}) => {
        this.skinTable.data = list
      })
    },
    // 获取视频号数据
    handleVideoTabClick() {
      const param = {
        field: this.pdFieldMap[this.videoTable.nm],
        c_type: this.pdProductTypeMap.video,
        date_at: this.formData.date,
        ...this.videoTable.sort
      }
      // 获取数据
      getPdProductStat(param).then(({model: {list}}) => {
        this.videoTable.data = list
      })
    },
  },
  mounted() {
    this.defaultTime()
    this.getList()
    this.getData()
    this.getPdProductData()
  }
}
</script>

<style>
.cell-click {
  color: #1890FF;
  cursor: pointer;
}

.pagination-container {
  background: #fff;
  padding: 10px;
  line-height: 1;
  /*border: #ff00fe 1px dashed;*/
  text-align: right;
}

.pagination-container.hidden {
  display: none;
}
</style>
